import { push } from 'react-router-redux'

import { SET_TOKEN, SET_USER, LOGOUT, ADD_FAVORITE, REMOVE_FAVORITE, ADD_FILTER, DELETE_FILTER, DISMISS_MAINTENANCE_INFO } from '../constants/actions'
import { request } from './api'

export const API_CALL = 'API_CALL'

export function login(username, password) {
    return dispatch => dispatch(request('/login', {
        method: 'POST',
        data: { username, password }
    })).then(data => {
        const { token } = data
        dispatch({
            type: SET_TOKEN,
            token
        })
        return dispatch(loadUser())
    })
}

export function loadUser() {
    return dispatch => dispatch(request('/user'))
        .then(user => {
            dispatch({
                type: SET_USER,
                user
            })
        })
}

export function logout() {
    return dispatch => {
        dispatch({
            type: LOGOUT
        })
        dispatch(push('/login'))
    }
}

export function redirect(location) {
    return push(location)
}

export function home() {
    return push('/')
}

const responses = {}

function hasChanged(key, data) {
    var serialized = JSON.stringify(data)
    if(data && (!responses[key] || responses[key] != serialized)) {
        responses[key] = serialized
        return true
    }
    return false
}

export function getSubscribers(params) {
    return (dispatch, getState) => dispatch(request('subscribers', params && { params }))
        .then(subscribers => {
            if (hasChanged('subscribers', subscribers)) {
                dispatch({
                    type: 'SET_SUBSCRIBERS',
                    subscribers
                })
            }
        })
}

export function getCalls() {
    return (dispatch, getState) => dispatch(request('calls'))
        .then(calls => {
            if (hasChanged('calls', calls)) {
                dispatch({
                    type: 'SET_CALLS',
                    calls
                })
            }
        })
}

export function getConfig() {
    return (dispatch, getState) => dispatch(request('config'))
        .then(config => {
            if (hasChanged('config', config)) {
                dispatch({
                    type: 'SET_CONFIG',
                    config
                })
            }
            return config
        })
}

export function dismissMaintenanceInfoAlert(id) {
    return {
        type: DISMISS_MAINTENANCE_INFO,
        id
    }
}

export function getCallHistory(subscriber) {
    return dispatch => dispatch(request('history/' + subscriber.username))
        .then(callHistory => {
            dispatch({
                type: 'SET_CALL_HISTORY',
                callHistory
            })
            return callHistory
        })
}

export function createCall(caller, callee, profile, message) {
    const data = {
        caller: caller.username || caller,
        callee: callee.username || callee.phoneNumber || callee,
        profile,
        message
    }
    return dispatch => dispatch(request('calls', { method: 'POST', data }))
        .then(response => {
            dispatch(getCalls())
            dispatch(home())
        })
}

export function terminateCall(call) {
    const data = {
        hash_entry: call.hash_entry,
        hash_id: call.hash_id,
        caller: call.username,
        callee: call.dst_username
    }
    return dispatch => dispatch(request('calls', { method: 'DELETE', data }))
        .then(response => {
            dispatch({
                type: 'CALL_TERMINATED'
            })
            dispatch(getCalls())
        })
}

export function handleError(error) {
    return dispatch => dispatch(addNotification('error', error.message || error))
}

export function addNotification(type, message) {
    return dispatch => {
        const notification = { type, message }
        dispatch({
            type: 'ADD_NOTIFICATION',
            notification
        })
        setTimeout(() => {
            dispatch({
                type: 'DISMISS_NOTIFICATION',
                notification
            })
        }, type === 'error' ? 5000 : 2000)
    }
}

export function dismissNotification(idx) {
    return {
        type: 'DISMISS_NOTIFICATION',
        index: idx
    }
}

export function subscriberFilterChanged(filter) {
    return {
        type: 'SUBSCRIBER_FILTER_CHANGED',
        filter
    }
}

export function activeCallListFilterChanged(filter) {
    return {
        type: 'ACTIVECALLLIST_FILTER_CHANGED',
        filter
    }
}

export function subscriberOrderChanged(sortOrder) {
    return {
        type: 'SUBSCRIBER_ORDER_CHANGED',
        sortOrder
    }
}

export const addFavorite = subscriber => ({
    type: ADD_FAVORITE,
    subscriber
})

export const removeFavorite = subscriber => ({
    type: REMOVE_FAVORITE,
    subscriber
})

export const addFilter = (name, filter) => ({
    type: ADD_FILTER,
    name,
    filter
})

export const deleteFilter = name => ({
    type: DELETE_FILTER,
    name
})


// WEBPACK FOOTER //
// ./actions/index.js